import Swal from 'sweetalert2'
import moment from 'moment';

export default {
    name: 'AddUser',
    created() {
        this.GetInfo();
        this.GetMunicipalities();
    },
    components: {
       
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Municipalities: [],
            MunicipalitId:'',
            Info: [],
            DeviceInfo: [],



            ViewDialog: false,
            selsectidItem: '',
            EditDialog: false,
            SelectedItem: '',


            ruleForm: {
                Name: '',
                EngilshName: '',
                MunicipalitId: '',
                //ChairCount: 0,
            },
            rules: {

                MunicipalitId: [
                    { required: true, message: 'الرجاء  اختيار البلدية', trigger: 'blur' },
                ],

                Name: [
                    { required: true, message: 'الرجاء إدخال إسم المدينة', trigger: 'blur' },
                    { required: true, pattern: /[\u0600-\u06FF]/, message: 'الرجاء إدخال حروف العربية فقط', trigger: 'blur' }
                ],

                EngilshName: [
                    { required: true, message: 'الرجاء إدخال إسم المدينة', trigger: 'blur' },
                    { required: true, pattern: /^[a-zA-Z ]+$/, message: 'الرجاء إدخال حروف انجليزية فقط', trigger: 'blur' }
                ],

                //ChairCount: [
                //    { required: true, message: 'الرجاء إدخال عدد الكراسي', trigger: 'blur' },
                //],
            },
            
        };
    },
    methods: {

        refresh() {
            this.MunicipalitId = '';
            this.GetInfo();
        },
      
        GetMunicipalities() {
            this.$blockUI.Start();
            this.$http.GetAllMunicipalities()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Municipalities = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }


            this.$blockUI.Start();
            this.$http.GetHospitals(this.pageNo, this.pageSize, this.MunicipalitId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pages = 0;
                });

        },

        deleteItem(id) {
            Swal.fire({
                title: 'هـل انت متأكد من عملية الحذف ؟',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `تأكيد العملية`,
                denyButtonText: `الغاء العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.deleteHospitals(id)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.FormPorgress = 100;
                            Swal.fire({
                                icon: 'success',
                                title: '..نجـاح العملية',
                                html:
                                    response.data,
                                showCancelButton: true,
                                //confirmButtonText: `حـفظ`,
                                denyButtonText: `خروج`,
                            }).then(() => {
                                this.$blockUI.Stop();
                                this.GetInfo();
                            });


                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$notify({
                                title: 'خطأ بعملية الحذف',
                                dangerouslyUseHTMLString: true,
                                type: 'error',
                                message: err.response.data
                            });
                        });
                    return;
                }
            })
        },
         
        EditItem(item) {
            //this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.MunicipalitId = item.municipalitId;
            this.ruleForm.EngilshName = item.engilshName;
            //this.ruleForm.ChairCount = item.chairCount;
            this.EditDialog = true;
        },

        ViewProfileItem(id) {
            this.ViewDialog = true;
            this.selsectidItem = id;
            this.GetDeviceInfo();
        },

        GetDeviceInfo() {

            this.$blockUI.Start();
            this.$http.GetHospitalDevicesInfo(this.selsectidItem)
                .then(response => {
                    this.$blockUI.Stop();
                    this.DeviceInfo = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pages = 0;
                });

        },

       



        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.EditCity(formName);
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        EditCity(formName) {

            this.$blockUI.Start();
            this.$http.EditHospitals(this.ruleForm)
                .then(response => {
                    this.resetForm(formName);
                    this.$blockUI.Stop();
                    this.EditDialog = false;
                    this.GetInfo();
                    Swal.fire({
                        icon: 'success',
                        title: '..نجـاح العملية',
                        // text: '<strong>Something went wrong!</strong>',
                        html:
                            response.data,
                        // showCloseButton: true,
                        showCancelButton: false,
                        //confirmButtonText: `حـفظ`,
                        //denyButtonText: `مواق`,
                    }).then(() => {

                    });
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$notify({
                        title: 'خطأ بالعملية ',
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                        message: err.response.data
                    });
                });
        }

        

    }
}
